import React from 'react';
import { useSearchParams } from 'react-router';

export type ScreeningsTab = 'integrations' | 'screenings';

export const useScreeningsTab = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const screeningsTab = searchParams.get('screeningsTab') ?? 'screenings';

    const setScreeningsTab = React.useCallback(
        (value: ScreeningsTab) => {
            setSearchParams(
                (prevValues) => {
                    prevValues.set('screeningsTab', value);
                    return prevValues;
                },
                { replace: true },
            );
        },
        [setSearchParams],
    );

    return {
        screeningsTab,
        setScreeningsTab,
    };
};
